// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton-module__container___fqOGu","image":"IconButton-module__image___2Ip7a"};